// src/contexts/PermissionContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../service/caller';
import { toast } from 'react-toastify';

// Création du contexte
const PermissionContext = createContext();

// Provider du contexte
export const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fonction pour charger les permissions
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const response = await api.get('api/getallpermissions');
        setPermissions(response.data);
      } catch (error) {
        toast.error("Error fetching permissions");
        console.error("Error fetching permissions:", error);
      }
    };

    // Fonction pour récupérer les données de l'utilisateur connecté
    const fetchUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
      } catch (error) {
        toast.error("Failed to fetch user data");
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
    fetchUserData();
  }, []);

  // Fonction pour vérifier si l'utilisateur a une permission spécifique
  const hasPermission = (permissionName) => {
    if (!userData || !userData.permissions) return false;
    
    return userData.permissions.some(perm => 
      typeof perm === 'string' 
        ? perm === permissionName 
        : perm.name === permissionName || perm._id === permissionName
    );
  };

  // Valeurs exposées par le contexte
  const value = {
    permissions,
    userData,
    loading,
    hasPermission
  };

  return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
};

// Hook personnalisé pour utiliser le contexte
export const usePermissions = () => {
  const context = useContext(PermissionContext);
  if (context === undefined) {
    throw new Error('usePermissions must be used within a PermissionProvider');
  }
  return context;
};